import React, { Component } from "react";

import classes from "./AssignmentMainDashboard.module.css";
import AssignmentCard from "./AssignmentCard";
import { Dialog, DialogActions } from "@material-ui/core";
import closeLogo from "../../../../assets/img/closeIcon.svg";
import noAssessmentLogo from "../../../../assets/img/noAssessment.svg";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import LayoutDashboard from "../../../Layout_Dashboard/Layout_Dashboard";
import { withTranslation } from "react-i18next";

import {
  createAssessment,
  fetchAssessment,
  filterAssessment,
} from "../../../../store/actions/assessment.action";
import { fetchAssessmentResponces } from "../../../../store/actions/questionAnswer.action";
import { setIsWebView } from "../../../../store/actions/assessment.action";
import {
  getusername,
  getClassInfo,
  getKneuraId,
} from "../../../../utils/authentication-access";

// Material UI
import { MPaper } from "../../../../UI";
import AssessmentListEvent from "./AssessmentListEvent";

// Material UI Icons

class AssignmentDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addAssignment: false,
      errorAssignmentNameText: "",
      errorAssignmentNameStatus: false,
      newAssignmentName: "",
      status: "All",
      allAssessment: [],
      sortButtonToggle: false,
    };
  }

  closeAssignmentDialog = () => {
    this.setState({ addAssignment: false });
  };

  openAssignmentDialog = () => {
    this.setState({
      addAssignment: true,
      errorAssignmentNameText: "",
      errorAssignmentNameStatus: false,
      newAssignmentName: "",
    });
  };

  onAssignmentNameEnter = (event) => {
    this.setState({
      newAssignmentName: event.target.value,
      errorAssignmentNameText: "",
      errorAssignmentNameStatus: false,
    });
  };

  createAssignment = () => {
    if (this.state.newAssignmentName === "") {
      this.setState({
        errorAssignmentNameStatus: true,
        errorAssignmentNameText: "Please Enter Assessment Name",
      });
    } else if (this.state.newAssignmentName !== "") {
      this.props.createAssessment(
        getClassInfo().kneuraId,
        this.state.newAssignmentName,
        getusername()
      );
    }
    this.closeAssignmentDialog();
  };

  handleChange = (sortStatus) => async (event) => {
    this.setState({ status: sortStatus });
    
      let classID = getClassInfo().kneuraId;
      await this.props.fetchAssessment(classID);
      this.getAllAssessment();
    if (sortStatus == "Completed") {
      let assessments = this.state.allAssessment.filter((item) => {
        return item.AssessmentStatus == "Completed";
      });
      this.props.filterAssessment(assessments);
    } else if (sortStatus == "NotAttempted") {
      let assessments = this.state.allAssessment.filter((item) => {
        return item.AssessmentStatus == "NotAttempted";
      });
      this.props.filterAssessment(assessments);
    } else if (sortStatus == "InProgress") {
      let assessments = this.state.allAssessment.filter((item) => {
        return item.AssessmentStatus == "InProgress";
      });
      this.props.filterAssessment(assessments);
    }else if (sortStatus == "PendingEvaluation") {
      let assessments = this.state.allAssessment.filter((item) => {
        return item.AssessmentStatus == "PendingEvaluation";
      });
      this.props.filterAssessment(assessments);
    }
    this.sortButtonClickHandler(event);
  };

  async componentDidMount() {
    document.title = "My Test";
    if (getClassInfo()) {
      let classID = getClassInfo().kneuraId;
      await this.props.fetchAssessmentResponces(classID, getKneuraId());
      await this.props.fetchAssessment(classID);
      this.setState({ allAssessment: this.props.assessmentsData });
    }
    this.props.setIsWebView(this.props.webViewActivated);
  }

  componentDidUpdate(prevProps) {
    document.title = "My Test";
    if (prevProps.assessmentsData === this.props.assessmentsData) {
      return;
      // let classID = getClassInfo().kneuraId;
      // await this.props.fetchAssessmentResponces(classID, getKneuraId());
      // await this.props.fetchAssessment(classID);
      // this.setState({ allAssessment: this.props.assessmentsData });
    }
    this.setState({ allAssessment: this.props.assessmentsData });
  }

  getAllAssessment = () => {
    const assessments = [];
    this.props.assessmentsData.forEach((assessment) => {
      this.props.assessmentResponses.every((response) => {
        if (assessment.id === response.assessmentId) {
          assessments.push({
            ...assessment,
            AssessmentStatus: response.status,
          });
          return false;
        }
        return true;
      });
    });

    assessments.sort(function (a, b) {
      return new Date(b.publishedOn) - new Date(a.publishedOn);
    });

    this.props.filterAssessment(assessments);
    this.setState({ allAssessment: assessments });
  };
  sortButtonClickHandler = (event) => {
    this.setState({
      sortButtonToggle: !this.state.sortButtonToggle,
      sortButtonTarget: event.target,
    });
  };
  render = () => {
    const { t } = this.props;
    return (
      <>
        <AssessmentListEvent />
        <LayoutDashboard
          hideClassSwitcher={this.props.webViewActivated}
          classname={this.props.classname}
          breadCrumb={["Tests"]}
          openClassesDrawer={this.props.openClassSideBar}
        >
          <MPaper
            style={{
              width: "100%",
              height: "100%",
              boxSizing: "border-box",
              paddingBottom: "2vh",
            }}
            elevation={0}
          >
            <div className={classes.dashboardContainer}>
              <div className={classes.headergrid}>
                <div className={classes.title}>{t("My Tests")}</div>
                <div className={classes.filter}>
                  <div className={classes.filtertext}>{t("FILTER")}</div>
                  <Button
                    aria-controls="simple-menu"
                    color="primary"
                    aria-haspopup="true"
                    className={classes.SortButton}
                    endIcon={<ArrowDropDownIcon />}
                    onClick={this.sortButtonClickHandler}
                  >
                    {t(this.state.status)}
                  </Button>
                  <Menu
                    keepMounted
                    anchorEl={this.state.sortButtonTarget}
                    id="simple-menu"
                    open={Boolean(this.state.sortButtonToggle)}
                    onClose={this.sortButtonClickHandler}
                  >
                    <MenuItem onClick={this.handleChange("All")}>
                      {t("ALL")}
                    </MenuItem>
                    <MenuItem onClick={this.handleChange("Completed")}>
                      {t("COMPLETED")}
                    </MenuItem>
                    <MenuItem onClick={this.handleChange("NotAttempted")}>
                      {t("NOT ATTEMPTED")}
                    </MenuItem>
                    <MenuItem onClick={this.handleChange("InProgress")}>
                      {t("IN PROGRESS")}
                    </MenuItem>
                    <MenuItem onClick={this.handleChange("PendingEvaluation")}>
                      {t("PENDING EVALUATION")}
                    </MenuItem>
                  </Menu>
                </div>
              </div>
              {this.props.assessmentsData.length > 0 ? (
                this.props.assessmentsData.map((item) => {
                  if (item.status !== "Unpublished") {
                    return (
                      <AssignmentCard
                        item={item}
                        history={this.props.history}
                      />
                    );
                  }
                })
              ) : (
                <div className={classes.noassessment}>
                  <div className={classes.notification}>
                    <img
                      src={noAssessmentLogo}
                      className={classes.noassessmentlogo}
                      alt="No Assessment"
                    />
                  </div>
                </div>
              )}
            </div>
          </MPaper>

          <Dialog
            fullWidth={true}
            maxWidth={"sm"}
            className="overlay"
            open={this.state.addAssignment}
            onClose={this.closeAssignmentDialog}
          >
            <div className="dialog-modal-header bg-primary">
              <div />
              <div className="text-center">
                <img
                  className="close-icon hover"
                  onClick={this.closeAssignmentDialog}
                  src={closeLogo}
                  alt="Close"
                />
              </div>
            </div>
            <div className="modal-card">
              <div className="modal-title">{t("Create an Assignment")}</div>
              <TextField
                id="assignmentname"
                label="Assignment Name"
                className="input-field"
                margin="normal"
                autoFocus
                value={this.state.newAssignmentName}
                helperText={this.state.errorAssignmentNameText}
                error={this.state.errorAssignmentNameStatus}
                onChange={this.onAssignmentNameEnter.bind(this)}
              />

              <DialogActions>
                <button
                  className="btn-button-blank"
                  onClick={this.closeAssignmentDialog}
                >
                  {t("Cancel")}
                </button>
                <button
                  className="btn-button-learn"
                  onClick={this.createAssignment}
                >
                  {t("Continue")}
                </button>
              </DialogActions>
            </div>
          </Dialog>
        </LayoutDashboard>
      </>
    );
  };
}

const mapStateToProps = (state) => {
  const assessments = [];
  state.assessmentsReducer.assessments.map((assessment) => {
    state.questionanswer.assessmentresponses.every((response) => {
      if (assessment.id === response.assessmentId) {
        assessments.push({ ...assessment, AssessmentStatus: response.status });
        return false;
      }
      return true;
    });
  });
  assessments.sort(function (a, b) {
    return new Date(b.publishedOn) - new Date(a.publishedOn);
  });

  return {
    assessmentsData: assessments,
    assessmentResponses: state.questionanswer.assessmentresponses,
  };
};

export default connect(mapStateToProps, {
  createAssessment,
  fetchAssessment,
  filterAssessment,
  fetchAssessmentResponces,
  setIsWebView
})(withTranslation()(AssignmentDashboard));
